import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const chapters = [{
  icon: '🧠',
  title: 'El Diagnóstico del Estrés Transmitido',
  desc: 'Cómo la inflación, la inseguridad y la incertidumbre argentina se filtran en tu pareja — y cómo dejar de proyectar eso sobre el otro.',
  tag: 'Capítulo 1'
}, {
  icon: '⏱️',
  title: 'La Tregua de los 5 Minutos',
  desc: 'El Protocolo S.O.S para salir de la escalada antes del punto de no retorno. Incluye la "palabra clave" que para cualquier pelea en segundos.',
  tag: 'Capítulo 2'
}, {
  icon: '📊',
  title: 'El Método del Tablero Logístico',
  desc: 'Gestionar la casa como una empresa sin matar el deseo. Una reunión semanal de 20 min que elimina el resentimiento por asimetría.',
  tag: 'Capítulo 3'
}, {
  icon: '🎒',
  title: 'Auditoría de Resentimientos + Intimidad en Crisis',
  desc: 'Vaciar la mochila emocional de las "facturas viejas". La Regla de los 3 Abrazos de 20 segundos respaldada por ciencia.',
  tag: 'Capítulo 4 & 5'
}, {
  icon: '📜',
  title: 'El Contrato de Convivencia en Crisis',
  desc: 'El documento firmado que protege tu pareja mientras navegás la tormenta. Incluye plantilla lista para completar esta misma noche.',
  tag: 'Capítulo Final'
}];
export function UniqueMechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038]" data-id="element-370" data-mp="ai81m8xtnf0v">
      <div className="max-w-5xl mx-auto px-6" data-id="element-371" data-mp="5n14xl2yzalg">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-372" data-mp="ka42tsv7fl9b">
          <div className="mx-auto mb-12 max-w-2xl text-center" data-id="element-373" data-mp="cice2d1jw76m">
            <div className="mb-5 inline-block rounded-full bg-[#E5A83B]/15 px-4 py-1.5 text-sm font-bold tracking-wide text-[#E5A83B]" data-id="element-374" data-mp="gkh6x9k6czs7">
              QUÉ VAS A ENCONTRAR ADENTRO
            </div>
            <h2 className="font-serif text-3xl font-bold text-white md:text-4xl lg:text-5xl" data-id="element-375" data-mp="qa91i3s9xswo">
              Herramientas para volver a sentirse del mismo lado
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-[#C4B5FD]" data-id="element-376" data-mp="3ps0bjnk3rjj2">
              Cinco pilares simples, pensados para pasar de la tensión diaria a
              conversaciones que sí construyen.
            </p>
          </div>

          <div className="grid gap-4 md:grid-cols-2" data-id="element-377" data-mp="7kkcssf0n8pr">
            {chapters.map((chapter, index) => <motion.article key={chapter.title} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.45,
            delay: index * 0.08,
            ease: 'easeOut'
          }} className={`flex gap-4 rounded-2xl bg-[#E0D7FF] p-6 ${index === chapters.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-378" data-mp="1e0wcwz1ef0nz" data-mpi={index}>
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#7C3AED]/10 text-3xl" data-id="element-379" data-mp="2fu0i1hx1ona7">
                  {chapter.icon}
                </div>
                <div data-id="element-380" data-mp="25vb0jq9294uh">
                  <p className="text-xs font-bold uppercase tracking-wider text-[#7C3AED]" data-id="element-381" data-mp="917vzbw0st11">
                    {chapter.tag}
                  </p>
                  <h3 className="mt-1 font-serif text-xl font-bold text-[#1E0A3C]" data-id="element-382" data-mp="436aylf1ajmx">
                    {chapter.title}
                  </h3>
                  <p className="mt-2 font-sans text-sm leading-relaxed text-[#3B1F6E]" data-id="element-383" data-mp="c0ykhc2hvn0e">
                    {chapter.desc}
                  </p>
                </div>
              </motion.article>)}
          </div>
        </motion.div>
      </div>
    </section>;
}